import { call, put } from 'redux-saga/effects';
import processError from '../../../utils/processError';
import { createCameraFailed, createCameraSuccessful } from '../actions';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import makeRequest from '../../../utils/makeRequest';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { CREATED, OK } from '../../../configs/serverStatusCodes';
import { BACKEND_URL } from '../../../configs';

export default function* createCamera(action) {
  try {
    const url = `${BACKEND_URL}/api/v1/camera/`;
    const dataResponse = yield makeRequest(url, action.payload, action, 'POST', true);
    if (dataResponse.status === OK || dataResponse.status === CREATED) {
      const data = yield dataResponse.json();
      yield put(createCameraSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(createCameraFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(createCameraFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
